export function formatMySQLDate(date) {
    if (!date) return '';

    // Try to parse the date, whether it's ISO or already a Date object
    const parsedDate = date instanceof Date ? date : new Date(date);

    // Check if the date is valid
    if (isNaN(parsedDate.getTime())) return '';

    const day = parsedDate.getDate().toString().padStart(2, '0');
    const month = (parsedDate.getMonth() + 1).toString().padStart(2, '0');
    const year = parsedDate.getFullYear();

    let hours = parsedDate.getHours();
    const minutes = parsedDate.getMinutes().toString().padStart(2, '0');

    const amPm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12 || 12;

    return `${day}.${month}.${year} - ${hours}:${minutes} ${amPm}`;
}

// date formatting for short duration trades
export function formatSmallTradeDate(date) {
    if (!date) return '';
 
    // Try to parse the date, whether it's ISO or already a Date object
    const parsedDate = date instanceof Date ? date : new Date(date);
 
    // Check if the date is valid
    if (isNaN(parsedDate.getTime())) return '';
 
    const day = parsedDate.getDate().toString().padStart(2, '0');
    const month = (parsedDate.getMonth() + 1).toString().padStart(2, '0');
    const year = parsedDate.getFullYear();
 
    let hours = parsedDate.getHours();
    const minutes = parsedDate.getMinutes().toString().padStart(2, '0');
    const seconds = parsedDate.getSeconds().toString().padStart(2, '0');
 
    const amPm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12 || 12;
 
    return `${day}.${month}.${year} - ${hours}:${minutes}:${seconds} ${amPm}`;
}

export function formatChartDate(date) {
    if (!date) return '';

    // Try to parse the date, whether it's ISO or already a Date object
    const parsedDate = date instanceof Date ? date : new Date(date);

    // Check if the date is valid
    if (isNaN(parsedDate.getTime())) return '';

    const day = parsedDate.getDate().toString().padStart(2, '0');
    const month = (parsedDate.getMonth() + 1).toString().padStart(2, '0');
    let year = parsedDate.getFullYear();
    year %= 100;

    return `${day}.${month}.${year}`;
}